// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';

// const Wysiwyg = ({
//   containerId,
//   containerClass,
//   htmlText,
// }) => (
//   htmlText ?
//     <Wrapper
//       containerId={containerId}
//       containerClass={containerClass}
//     >
//       <div className="Wysiwyg" dangerouslySetInnerHTML={{__html: htmlText}}/>
//     </Wrapper> :
//     null
// );
//
// Wysiwyg.propTypes = {
//   containerId: PropTypes.string,
//   containerClass: PropTypes.string,
//   htmlText: PropTypes.string,
// };
//
// Wysiwyg.defaultProps = {
//   containerId: null,
//   containerClass: null,
//   htmlText: null,
// };

// export default Wysiwyg;

export default class Wysiwyg extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    htmlText: PropTypes.string,
    inFeatureCategoriesHorizontal: PropTypes.bool,
    parentColumn: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    htmlText: null,
    inFeatureCategoriesHorizontal: false,
    parentColumn: null,
  };
  constructor(props) {
    super(props);
    // this.state = {
    //   firstStyle: props.inFeatureCategoriesHorizontal ? { opacity: 0, float: 'left', } : null,
    // };
    this.refsContent = null;
  }
  // componentDidMount() {
  //   const { inFeatureCategoriesHorizontal } = this.props;
  //   if (inFeatureCategoriesHorizontal) {
  //     this.setState({ firstStyle: null });
  //   }
  // }
  render() {
    const {
      containerId,
      containerClass,
      htmlText,
    } = this.props;

    if (!htmlText) {
      return null;
    }

    let isColumnLauoutMode = false;
    if (this.props.parentColumn === 'oneColumnLayout' || this.props.parentColumn === 'twoColumnLayout' || this.props.parentColumn === 'threeColumnLayout' || this.props.parentColumn === 'fourColumnLayout') {
      isColumnLauoutMode = true;
    }
    
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div
          className={'Wysiwyg' + ((isColumnLauoutMode === true) ? ' column-layout' : '')}
          dangerouslySetInnerHTML={{__html: htmlText}}
          ref={(component) => (this.refsContent = component)}
        />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/wysiwyg/index.jsx